<mat-card [formGroup]="accountDetail">
    <h4>Account Details</h4>
    <div class="row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>Account Number</mat-lable>
                <input matInput formControlName="accountNumber" placeholder="Account Number" (keypress)="onlyNumbersAllowed($event)" (paste)="handlePaste($event)"/>
                <mat-error *ngIf="accountDetail.controls.accountNumber.touched && accountDetail.controls.accountNumber.hasError('minlength')">
                    Account minimum length is 8.
                </mat-error>
                <mat-error *ngIf="accountDetail.controls.accountNumber.touched && !accountDetail.controls.accountNumber.valid">
                    Acc Number is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>Name On Account</mat-lable>
                <input matInput formControlName="nameOnAccount" placeholder="Name On Account"/>
                <mat-error *ngIf="accountDetail.controls.nameOnAccount.touched && !accountDetail.controls.nameOnAccount.valid">
                    Name is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <mat-form-field>
                <mat-lable>Street Address</mat-lable>
                <input matInput formControlName="streetAddress" placeholder="Street Address"/>
                <mat-error *ngIf="accountDetail.controls.streetAddress.touched && !accountDetail.controls.streetAddress.valid">
                    Street Address is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>Routing Number</mat-lable>
                <input matInput formControlName="routingNumber" placeholder="Routing Number" (keypress)="onlyNumbersAllowed($event)" (paste)="handlePaste($event)"/>
                <mat-error *ngIf="accountDetail.controls.routingNumber.touched && !accountDetail.controls.routingNumber.valid">
                    Routing Number is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>City</mat-lable>
                <input matInput formControlName="city" placeholder="City"/>
                <mat-error *ngIf="accountDetail.controls.city.touched && !accountDetail.controls.city.valid">
                    City is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>State</mat-lable>
                <input matInput formControlName="state" placeholder="State"/>
                <mat-error *ngIf="accountDetail.controls.state.touched && !accountDetail.controls.state.valid">
                    State is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-lable>ZipCode</mat-lable>
                <input matInput formControlName="zipCode" placeholder="ZipCode" (keypress)="onlyNumbersAllowed($event)" (paste)="handlePaste($event)" maxlength="5"/>
                <mat-error *ngIf="accountDetail.controls.zipCode.touched && !accountDetail.controls.zipCode.valid">
                    ZipCode is mandatory.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
   
    <div *ngIf="!isSubmitting">
        <button color="accent" class="paymentButton" style="background-color: rgb(67, 115, 206);" 
          (click)="onUpdateAccountDetail()">Update</button> &nbsp;
          <button color="warn" class="paymentButton" 
          (click)="onCancel()">Cancel</button>
    </div>
</mat-card>